import { render, staticRenderFns } from "./AboutView.vue?vue&type=template&id=109e2a90&scoped=true"
import script from "./AboutView.vue?vue&type=script&lang=ts"
export * from "./AboutView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109e2a90",
  null
  
)

export default component.exports